import styled from 'styled-components';

import {TypographyCard} from '@dms/teas';

export const WrapperCard = styled(TypographyCard)`
  margin: ${({theme}) => theme.getSize(4)} 0;
  position: relative;
`;
